import { render, staticRenderFns } from "./AskBuildingOwner.vue?vue&type=template&id=09722c9c&"
import script from "./AskBuildingOwner.vue?vue&type=script&lang=js&"
export * from "./AskBuildingOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports